// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-c200b652]{margin:40px auto 6px;color:#282729;font-size:28px;line-height:40px;font-weight:600;text-align:center}.sure_btn[data-v-c200b652]{margin-top:30px!important}.link-login[data-v-c200b652]{margin-top:20px;font-size:14px;line-height:20px;text-align:center}.link-login .high_light[data-v-c200b652]{margin:0 4px;color:#ff3973;cursor:pointer}", ""]);
// Exports
module.exports = exports;
